if (!customElements.get('swym-wishlist-page')) {
    class SwymWishlistPage extends HTMLElement {
        constructor() {
            super();
            this._initializeSwymComponent();
        }

        _init(swat) {
            this._initializeSelectors(swat);
            this._renderSFL();
            this._attachEventListeners(swat);
        }

        /* General functions */

        _initializeSwymComponent() {
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors(swat) {
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;
            window.isCartPage = location.href.includes('/cart') ? true : false;

            /* Page Header Selectors */
            this.swymcsSFLTab = this.querySelector('#swymcs-sfl-tab');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container');
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.EmptyContainer = this.querySelector('#swymcs-empty-grid');
            this.SFLProductsContainer = this.querySelector('#swymcs-sfl-products-grid');
            this.SFLEmptyContainer = this.querySelector('#swymcs-sfl-empty-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');

            /* Additional Options selectors */
            this.shareListButton = this.querySelector('#swymcs-share-list');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = document.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = document.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = document.querySelectorAll('.swymcs-additonal-popup-cancel-button');

            /* Share List popup selectors */
            this.shareListPopup = document.querySelector('#swymcs-share-list-popup');
            this.shareLinkField = document.querySelector('#swymcs-share-link-field');
            this.shareNameField = document.querySelector('#swymcs-share-name-field');
            this.shareEmailField = document.querySelector('#swymcs-share-email-field');
            this.shareMessageField = document.querySelector('#swymcs-share-message-field');
            this.shareListError = document.querySelector('#swymcs-share-email-field-error');
            this.emailShareButton = document.querySelector('#swymcs-confirm-share-list');
            this.emailShareCancelButton = document.querySelector('#swymcs-cancel-share-list');
            this.shareListPopupTitle = this.shareListPopup.querySelector('.swymcs-confirm-share-title');
            this.shareListPopupSubtitle = this.shareListPopup.querySelector('.swymcs-confirm-share-subtitle');
            this.copyLinkButton = document.querySelector('#swymcs-confirm-share-list--copy');
            this.copyLinkButtonText = this.copyLinkButton.querySelector('.swymcs-share-button-text');
            this.facebookShareButton = document.querySelector('#swymcs-confirm-share-list--facebook');
            this.twitterShareButton = document.querySelector('#swymcs-confirm-share-list--twitter');
            this.shareListPopupSenderNameLabel = this.shareListPopup.querySelector('[for="swymcs-share-name-field"]');
            this.shareListPopupSenderEmailLabel = this.shareListPopup.querySelector('[for="swymcs-share-email-field"]');
            this.shareListPopupSenderNotesLabel = this.shareListPopup.querySelector('[for="swymcs-share-message-field"]');

            this.emptyListTitle = this.emptyListContainer.querySelector('#swym-empty-wishlist-container-title');
            this.emptyListDescription = this.emptyListContainer.querySelector('#swym-empty-wishlist-container-description');
            this.emptyListButton = this.emptyListContainer.querySelector('#swym-custom-continue-shopping');

            /*SFL Selectors*/
            this.mainCart = document.querySelector("div#main-cart-items");

            if(!window.isCustomer){
                this.guestMessageButton = this.querySelector('#swymcs-guest-user-btn');
            }
        }

        _attachEventListeners(swat) {

            this.body.addEventListener('click', evt => this._overlayEvent(evt));
            swat.evtLayer.addEventListener(swat.JSEvents.StringsLoaded, (event) => {
                this._updateLocaleStrings();
            });
            
            /* Additional Options Events */
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));

            /* Share List Events */
            this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
            this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
            this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
            this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
            this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

            /* Lists grid buttons */
            this.SFLProductsContainer.addEventListener('click', this._eventsForProductsGrid);
            // setTimeout(() => { 
            //     this._attachCartDrawerListeners();
            // }, 1500);
            // if(this.mainCart)
                // this.mainCart.addEventListener('click', (evt) => this._addToSFL(evt, swat));
        }

        // _attachCartDrawerListeners(){
        //     this.cartDrawer = document.querySelector("div#CartDrawer-CartItems");
        //     // this.cartDrawer.addEventListener('click', (evt) => this._addToSFL(evt, swat));
        // }

        _updateLocaleStrings(){
            const swat = this.swat;
            const shareListNotesLabel = "Take a peek at what I’ve Saved For Later! 💖";

            /* MENU CONTAINER BUTTONS */
            this.swymcsSFLTab.textContent = swat.retailerSettings.Strings.SFLTabCTA;
  
            /* SHARE LIST POPUP CONTAINER */
            this.shareListPopupTitle.textContent = swat.retailerSettings.Strings.ShareWishlistPopupHeading;
            this.shareListPopupSubtitle.textContent = swat.retailerSettings.Strings.ShareWishlistAlternateShareLabel;
            this.copyLinkButtonText.textContent = swat.retailerSettings.Strings.ShareWishlistCopyLinkText;
            this.shareListPopupSenderNameLabel.textContent = swat.retailerSettings.Strings.ShareWishlistSenderName;
            this.shareNameField.placeholder = swat.retailerSettings.Strings.ShareWishlistNamePlaceholder;
            this.shareListPopupSenderEmailLabel.textContent = swat.retailerSettings.Strings.ShareWishlistRecipientsEmail;
            this.shareEmailField.placeholder = swat.retailerSettings.Strings.ShareWishlistEmailPlaceholder;
            this.shareListPopupSenderNotesLabel.textContent = swat.retailerSettings.Strings.ShareWishlistMessage;
            this.shareMessageField.placeholder = swat.retailerSettings.Strings.ShareWishlistNotePlaceholder;
            this.shareMessageField.value = shareListNotesLabel;
            this.emailShareButton.textContent = swat.retailerSettings.Strings.ShareWishlistEmailCTA;
  
            /* EMPTY LIST CONTAINER */
            this.emptyListTitle.textContent = swat.retailerSettings.Strings.SFLListEmptyText;
            this.emptyListButton.textContent = swat.retailerSettings.Strings.SFLOpenCartCTA;
        }

        async _renderSFL() {
            this.SFLList = await this._getSFL();
            const SFLProducts = this.SFLList.items;
            const shopifySFLProductsData = await this._getShopifyProductsData(SFLProducts);
            if(!shopifySFLProductsData.length){
                this._renderEmptyState();
            } else {
                this._renderProductsGrid(shopifySFLProductsData,'SFL');
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
            }
            this._showContainer(this.swymcsSFLTab);
            this.dispatchEvent(new CustomEvent('swym:product-grid-loaded'));
        }

        _renderEmptyState() {
            this._showContainer(this);
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
        }

        _renderProductsGrid(shopifyProducts,gridtype){
            let productMarkup = ``;
            if (!shopifyProducts.length) {
                this._renderEmptyState();
                // this._hideContainer(this.wishlistContainer);
            }
            else{
                shopifyProducts.forEach(async(pdp, index) => {
                    if (!pdp) return;
                    const product = pdp.productData;
                    const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                    const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                    const selectedVariantPrice = parseFloat(selectedVariant.price / 100.00).toFixed(2);
                    let addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${_swat.retailerSettings.Strings.AddToCartCTAAlreadyAdded}` : `${_swat.retailerSettings.Strings.AddToCartCTACanAdd}`) : `${_swat.retailerSettings.Strings.AddToCartCTAUnavailable}`;
                    const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                    const lid = pdp.lid;
                    let isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                    let isButtonDisabled = isSoldOut ? 'disabled' : '';
                    const imageSrc = selectedVariant ?.featured_image ?.src || product ?.featured_image || pdp.iu;
                    const productUrl = product.url + '?variant=' + selectedVariant.id;
                    let productTitle = product.title;
                    let productColour = productTitle.split('|')[1] || null;
                    productMarkup+= `
                        <div id="CartDrawer-Item-${index+1}" class="swymcs-product-card cart-item" role="row">
                            <div class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">
                                <span class="product_flag  "></span>
                                <div class="cart-item__details--wrapper">
                                <a href="${productUrl}" class="cart-item__name h4 break">${productTitle.split('|')[0]} </a>
                                <div class="product-option"> ${currencyCode}${selectedVariantPrice} </div>
                                <dl>
                                    <div class="product-option">
                                    <dt>Size:</dt>
                                    <dd> ${selectedVariantTitle}</dd>
                                    </div>
                                    ${productColour ? `<div class="product-option"><dt>Color:</dt><dd>${productColour}</dd></div>` : ''}
                                </dl>
                                <p class="product-option"></p>
                                <ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
                                </div>
                            </div>
                            <div class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">
                                <a href="${productUrl}" class="cart-item__link" tabindex="-1" aria-hidden="true">
                                </a>
                                <img class="cart-item__image" src="${imageSrc}" alt="${productTitle}" loading="lazy" width="150" height="226">
                            </div>
                            <div class="cart-item__quantity " role="cell" headers="CartDrawer-ColumnQuantity">
                                <quantity-popover>
                                <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
                                    <div class="cart-drawer-buttons">
                                        <button type="button" data-lid="${lid}" data-purpose="deleteSFL" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-has-after-css swymcs-button swymcs-product-delete-btn" aria-label="Remove ${product.title}">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16">
                                            <path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path>
                                            <path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path>
                                        </svg>
                                        </button>
                                        <button ${isButtonDisabled} type="button" data-purpose="cart" data-lid="${lid}" data-du="${pdp.reqURL}" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-qty="${pdp.qty}" class="${inCart} ${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${_swat.retailerSettings.Strings.MoveToCartCTA}" data-variant-cost="${selectedVariantPrice}">
                                            ${_swat.retailerSettings.Strings.MoveToCartCTA}
                                        </button>
                                    </div>
                                </div>
                                <div id="CartDrawer-LineItemError-${index+1}" class="cart-item__error" role="alert">
                                    <small class="cart-item__error-text"></small>
                                    <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                                    <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                                    <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                                    <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                                    <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
                                    </svg>
                                </div>
                                </quantity-popover>
                            </div>
                        </div>
                    `;
                });
                const container = this.SFLProductsContainer;
                if (container) {
                    container.innerHTML = productMarkup;
                    container.classList.remove('swymcs-empty-list');
                }
            }
        }

        async _renderShareListPopup(evt) {
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        _handleOutsideClick = (event) => {
            const page = document.querySelector('swym-wishlist-page');
            const container = page?.additionalOptionsPopupContainer;
            if (container && !container.contains(event.target)) {
                page._closeAdditionalOptionsPopup();
            }
        };

        _closeAdditionalOptionsPopup() {
            this._hideContainer(this.shareListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
            document.addEventListener('click', this._handleOutsideClick);
            this.copyLinkButtonText.textContent = swat.retailerSettings.Strings.ShareWishlistCopyLinkText;
        }

        async _renderShareList() {
            const list = await this._markListAsPublic();
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt) {
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
            }
        }

        _scrollToTop() {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer(selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer(selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
            document.removeEventListener('click', this._handleOutsideClick);
        }

        _showContainer(selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer(selector) {
            selector.classList.add('swym-hide-container');
        }

        /* Javascript APIs related functions */

        _getSFL(){
            return new Promise(async(resolve, reject) => {
                
                let initialiseOnSuccess = function(response) {
                    window._saveforLaterListId = response.list.lid; 
                }
                let initialiseOnError = function(error) {
                    console.log("There was an Error, while creating the Save For Later List", error);
                    reject(error);
                }
                this.swat.SaveForLater.init(initialiseOnSuccess, initialiseOnError);

                let fetchOnSuccess = function(response) {
                    resolve(response);
                }
                let fetchOnError = function(error) {
                    console.log("There was an Error, while we tried to fetch the Save For Later List", error);
                    reject(error);
                }
                this.swat.SaveForLater.fetch(window._saveforLaterListId, fetchOnSuccess, fetchOnError);                        
            });
        }

        async _getShopifyProductsData(products) {
            if (!products.length) return [];
            const section = this;
            let buggedProductsArray = [];
            let res = await Promise.all(products.map(async(pdp) => {
                try {
                    const productHandleString = pdp.du.split('/products/')[1];
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `https://${window.shopDomain}/products/${productHandle}`;
                    const productData = await fetch(`${reqURL}.js`);
                    const jsonData = await productData.json();
                    pdp.productData = jsonData;
                    pdp.reqURL = reqURL;
                    return pdp;
                } catch (error) {
                    const errorObj = {};
                    errorObj[pdp.du] = error;
                    buggedProductsArray.push(errorObj);
                    return null;
                }
            }));

            //console.log('Products with bugs - ', buggedProductsArray);
            res = res.filter(product => product && product.productData);
            return res;
        }

        _deleteProductFromSFLList(product, lid, parentNode) {
            return new Promise((resolve, reject) => {
                const onSuccess = async (deletedProduct) => {
                    parentNode.remove();
                    const noItemsLeft = !this.SFLProductsContainer.querySelector('.swymcs-product-card');
                    if(noItemsLeft) {
                        document.querySelector('swym-wishlist-page')?._renderProductsGrid([], 'SFL');
                        document.querySelector('swym-sfl-cart-page')?._renderProductsGrid([], 'SFL');
                    }
                    if(window.isCartPage) {
                        document.querySelector('swym-sfl-cart-page')?._renderSFL();
                        document.querySelector('swym-wishlist-page')?._renderSFL();
                    }
                    resolve(deletedProduct);
                };
        
                const onError = (error) => {
                    console.error("Error while deleting the Product", error);
                    const endTime = performance.now();
                    console.log(`_deleteProductFromSFLList (error) took ${endTime - startTime} ms`);
                    reject(error);
                };
                this.swat.SaveForLater.remove(lid, product, onSuccess, onError);
            });
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value == '' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if (isBlank || isInvalidString) {
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button) {
            button.textContent = "Adding...";
            const epi = +button.dataset.epi;
            const qty = +button.dataset.qty;
            const formData = {
                items: [{
                    id: epi,
                    quantity: qty
                }]
            };
        
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(res => res.json())
            .then(async (response) => {
                let cartDataJson;
                if (window.isCartPage) {
                    const addedvariantLineKey = response.items[0].key;
                    const cartData = await fetch('/cart.js');
                    cartDataJson = await cartData.json();
                    const keysArray = cartDataJson.items.map(item => item.key);
                    const index = keysArray.findIndex(key => key == addedvariantLineKey);
                    if (index !== -1) {
                        const { quantity } = cartDataJson.items[index];
                        document.querySelector('cart-items')?.updateQuantity(index + 1, quantity);
                    }
                    document.querySelector('swym-sfl-cart-page')?._renderSFL();
                }
                button.classList.add('swymcs-product-in-cart');
                button.textContent = _swat.retailerSettings.Strings.AddToCartCTAAlreadyAdded;
                if (!window.isCartPage) {
                    setTimeout(() => window._cartRefresh(cartDataJson), 100);
                }
                return response;
            })
            .catch((error) => {
                button.textContent = 'Move to cart';
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
                console.error('Error in _addProductToCart:', error);
            });
        }

        _markListAsPublic() {
            return new Promise(async(resolve, reject) => {
                this.swat.markListPublic(window._saveforLaterListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _prepareShareLink(list) {
            return new Promise(async(resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy() {
            navigator.clipboard.writeText(this.shareLinkField.textContent)
                .then(() => {
                    this.copyLinkButtonText.textContent = "Copied!";
                    this.swat.ui.showSuccessNotification({ message: 'Link Copied to Clipboard!' });
                })
                .catch(error => _swat.ui.showSuccessNotification({ message: error.description }));
        }

        _shareListByEmail() {
            const email = this._validateEmail();
            if (!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({ message: 'List shared successfully over mail' });
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({ message: error.description });
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window._saveforLaterListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform) {
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({ message: error.description });
            let platformShareUrlTemplate = '';
            if (platform == 'facebook')
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if (platform == 'twitter')
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`;
            _swat.shareListSocial(window._saveforLaterListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        /* Header functions */

        _addToSFL(button){
            // let target = evt.target.dataset;
            // if(target.purpose=="addToSFL")
            // {
            // const button = evt.target;
            button.textContent = "Saving for Later...";
                let products = []
                    products = [{
                    du: button.dataset.productUrl,
                    empi: button.dataset.productId,
                    epi: button.dataset.variantId,
                    qty: button.dataset.cartQuantity
                }];        
                let onSuccess = function(response) {
                    button.textContent = "Saved for Later";
                    const index = button.dataset.index;
                    const deleteButtonId = button.dataset.deleteButtonId;
                    document.querySelector(`#${deleteButtonId}`)?.dispatchEvent(new Event('click'));
                    setTimeout(function() {
                        if(window.isCartPage) {
                            document.querySelector('cart-items').updateQuantity(index, 0);
                            document.querySelector('swym-sfl-cart-page')._renderSFL();
                        }
                        window._cartRefresh();
                    }, 250)
                } 
                let onError = function(error) {
                    console.log("There was an Error, while Adding products to the Save For Later List", error);
                    target.textContent = "Save for Later";
                }
                this.swat.SaveForLater.add(window._saveforLaterListId, products, onSuccess, onError);
            // }    
        }

        /* Product Grid Events */

        async _eventsForProductsGrid(evt) {
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset ?.purpose;
            if (!purpose) return;
            evt.preventDefault();
            if (purpose == 'cart') 
            {
                page._addProductToCart(target);
                page._deleteProductFromSFLList([{
                    "du": target.dataset.du,
                    "empi": target.dataset.empi,
                    "epi": target.dataset.epi,
                }], target.dataset.lid, target.closest('.swymcs-product-card'));
            }
            else if (purpose == 'deleteSFL') {
                page._deleteProductFromSFLList([{
                    "du": target.dataset.du,
                    "empi": target.dataset.empi,
                    "epi": target.dataset.epi,
                }], target.dataset.lid, target.closest('.swymcs-product-card'));
            }
        }
    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
    class SwymSflCartPage extends SwymWishlistPage {
        constructor() {
            super();
            this._initializeSwymComponent();
        }

        _renderProductsGrid(shopifyProducts,gridtype){
            let productMarkup = `<table class="cart-items"><caption class="visually-hidden">My Bag</caption><tbody>`;
            if (!shopifyProducts.length) {
                this._renderEmptyState();
                // this._hideContainer(this.wishlistContainer);
            }
            else{
                this._showContainer(this.wishlistContainer);
                this._hideContainer(this.emptyListContainer);
                shopifyProducts.forEach(async(pdp, index) => {
                    if (!pdp) return;
                    const product = pdp.productData;
                    const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                    const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                    const selectedVariantPrice = parseFloat(selectedVariant.price / 100.00).toFixed(2);
                    let addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${_swat.retailerSettings.Strings.AddToCartCTAAlreadyAdded}` : `${_swat.retailerSettings.Strings.AddToCartCTACanAdd}`) : `${_swat.retailerSettings.Strings.AddToCartCTAUnavailable}`;
                    const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                    const lid = pdp.lid;
                    let isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                    let isButtonDisabled = isSoldOut ? 'disabled' : '';
                    const imageSrc = selectedVariant ?.featured_image ?.src || product ?.featured_image || pdp.iu;
                    const productUrl = product.url + '?variant=' + selectedVariant.id;
                    let productTitle = product.title;
                    productMarkup+= `
                        <tr class="cart-item swymcs-product-card" id="CartItem-${index+1}" role="row">
                            <td class="cart-item__media">
                                <div class="cart-item__image-container gradient global-media-settings">
                                    <img src="${imageSrc}" class="cart-item__image" alt="${product.title}" loading="lazy" width="150" height="226">
                                </div>
                            </td>
                            <td class="cart-item__details">
                                <a href="${productUrl}" class="cart-item__name h4 break">${productTitle}</a>
                                <div class="product-option">
                                    ${currencyCode}${selectedVariantPrice}
                                </div>
                                <dl>
                                    <div class="product-option">
                                        <dt>Size:</dt>
                                        <dd>${selectedVariantTitle}</dd>
                                    </div>
                                </dl>
                                <p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
                            </td>
                            <td class="cart-item__totals right medium-hide large-up-hide">
                                <svg xmlns="http://www.w3.org/2000/svg" class="loading__spinner hidden spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                                <div class="cart-item__price-wrapper"><span class="price price--end">
                                    $ 100.00
                                    </span></div>
                            </td>
                            <td class="cart-item__quantity">
                                <quantity-popover>
                                <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
                                    <div class="cart-drawer-buttons">
                                        <button ${isButtonDisabled} type="button" data-purpose="cart" data-lid="${lid}" data-du="${pdp.reqURL}" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-qty="${pdp.qty}" class="${inCart} ${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${_swat.retailerSettings.Strings.MoveToCartCTA}" data-variant-cost="${selectedVariantPrice}">
                                            ${_swat.retailerSettings.Strings.MoveToCartCTA}
                                        </button>
                                    </div>
                                </div>
                                <div id="CartDrawer-LineItemError-${index+1}" class="cart-item__error" role="alert">
                                    <small class="cart-item__error-text"></small>
                                    <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                                    <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                                    <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                                    <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                                    <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
                                    </svg>
                                </div>
                                </quantity-popover>
                            </td>
                            <td class="cart-item__totals right small-hide">
                                <div class="swymcs-delete-btn-container">
                                    <button type="button" data-lid="${lid}" data-purpose="deleteSFL" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-has-after-css swymcs-button swymcs-product-delete-btn" aria-label="Remove ${product.title}">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16">
                                            <path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path>
                                            <path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path>
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    `;
                });
                productMarkup += `</tbody></table>`;
                const container = this.SFLProductsContainer;
                if (container) {
                    container.innerHTML = productMarkup;
                    container.classList.remove('swymcs-empty-list');
                }
            }
            this._showContainer(this);
        }

    }
    customElements.define('swym-sfl-cart-page', SwymSflCartPage);
}   